import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FillerService } from '../../common/Service_tnFiller';
import { TooltipModule } from '../../common/index';
import { Router, NavigationExtras, ActivatedRoute, Params } from '@angular/router';
import { DetailComponent } from '../../detail/detail.component';

@Component({
	selector: 'app-tnsearchpanel',
	templateUrl: '../../themes/default/html/tnsearchpanel.component.html',
	styleUrls: ['../../themes/default/css/tnsearchpanel.component.scss'],
	providers: []
})

export class TnsearchpanelComponent {

  	localskin: string = 'h';
	localmode: boolean = false

	@Input()
	set skin(_skin: string) {
		this.localskin = _skin.toLowerCase();
		//console.log("Set skin = " + _skin);
	}
	@Input()
	set detail(_mode: boolean){
		this.localmode = _mode;
		//console.log(_mode);
	}

	

	public Selects = {
		All: 'Città',
		AllContracts: 'Contratti',
		AllCategories: 'Categorie',
		AllTypes: 'Tipologie'
	}

	listStat = {
		Count: 0
	};

	Slider = {
		isEnabled: false
	};

	filledFilters = {
		Groups: [],
		Categories: [],
		Types: [],
		Cities: [],
		CitiesCount: 0,
		Stats: {}
	};

	public searchFilters = {
		Category: '',
		Contract: '',
		Type: '',
		City: '',
		Rooms: '',
		bathRooms: '',
		carParks: '',
		listKind: 'all',
		// Range: [$scope.Slider.Options.min, $scope.Slider.Options.max],
		Range: {
			min: '0',
			max: '0'
		},
		surfaceRange: [],
		Services: {
			Elevator: false,
			Balcony: false,
			Panoramic: false,
			Garden: false,
			Radiators: false,
			Conditioner: false,
			Garage: false,
			animalsAdmit: false
		},
		uiCulture: 'it'
	};

	ctrl: any;
	isPendingChanges = false;

	constructor(private filler: FillerService, private router: Router, private activatedRoute: ActivatedRoute) {  

		// this.ctrl = new FormControl('', (control) => {
		//   // validate the value
		// });

		// this.ctrl.valueChanges.subscribe((value) => {
		//   // called when the value is updated
		// });

	}

	ngOnInit() {

		// controlla i query params per vedere se siamo in un'altra pagina
		new Promise((resolve, reject) => {
			this.activatedRoute.queryParams.subscribe((params: Params) => {
			
			if (params['City']) { this.searchFilters.City = params['City']; }
			if (this.searchFilters.City == '') { this.searchFilters.City =''; }

			if (params['Contract']) { this.searchFilters.Contract = params['Contract'] };
			if (this.searchFilters.Contract == '') { this.searchFilters.Contract = '0'; }

			if (params['Category']) { this.searchFilters.Category = params['Category'] };
			if (this.searchFilters.Category == '') { this.searchFilters.Category = '0'; }

			if (params['Type']) { this.searchFilters.Type = params['Type'] };
			if (this.searchFilters.Type == '') {this.searchFilters.Type = '0'; }
			
			this.searchFilters.Range.min = ((params['PriceRangeFrom'] != null || params['PriceRangeFrom'] != undefined) && params['PriceRangeFrom'] >0) ? params['PriceRangeFrom'] : 0 ;
			this.searchFilters.Range.max = ((params['PriceRangeTo'] != null || params['PriceRangeTo'] != undefined) && params['PriceRangeTo'] >0) ? params['PriceRangeTo'] : 0 ;
			this.searchFilters.surfaceRange[0] =((params['SurfaceRangeFrom'] !=null || params['SurfaceRangeFrom'] !=undefined ) && params['SurfaceRangeFrom'] >0 ) ? params['SurfaceRangeFrom'] : 0 ;
			this.searchFilters.surfaceRange[1] =((params['SurfaceRangeTo'] !=null || params['SurfaceRangeTo'] !=undefined) && params['SurfaceRangeTo'] >0 ) ? params['SurfaceRangeTo'] : 10000000000 ;
			
			// if (params['HasLift']) { this.payload.lift = params['HasLift'] };
			// if (params['HasBalcony']) { this.payload.balcony = params['HasBalcony'] };
			// if (params['IsPanoramic']) { this.payload.panoramic = params['IsPanoramic'] };
			// if (params['HasGarden']) { this.payload.garden = params['HasGarden'] };
			// if (params['HasRadiators']) { this.payload.radiators = params['HasRadiators'] };
			// if (params['HasConditioner']) { this.payload.conditioner = params['HasConditioner'] };
			// if (params['HasGarage']) { this.payload.garage = params['HasGarage'] };
			// if (params['IsAnimalsAdmit']) { this.payload.animalAdmit = params['IsAnimalsAdmit'] };

			// if (params['bathroomsPlusThan']) { this.payload.bathroomsPlusThan = params['bathroomsPlusThan'] };
			// if (params['carParkPlusThan']) { this.payload.carParkPlusThan = params['carParkPlusThan'] };
			// if (params['roomsPlusThan']) { this.payload.roomsPlusThan = params['roomsPlusThan'] };
			
			resolve(true);
			
		});
		}).then(
			e => { 
				this.UpdateFiller();
				this.OnChange_FillStats();       
			}
		);

		this.UpdateFiller();
		this.OnChange_FillStats();

	}

	UpdateFiller() {

		// Città
		this.filler.Get_CityInAds().subscribe(
		data => {
			this.filledFilters.Cities = Object.assign([], data.Items)
			this.filledFilters.CitiesCount = data.Count;
		}, err => { }
		);

		// Gruppi
		this.filler.Get_GroupList().subscribe(
		data => {
			this.filledFilters.Groups = Object.assign([], data.Items)
			//this.filledFilters.CitiesCount = data.Count;
		}, err => { }
		);

		// Categories
		this.filler.Get_CategoryInAds().subscribe(
		data => {
			this.filledFilters.Categories = Object.assign([], data.Items)
		}, err => { }
		);

		// Types
		this.filler.Get_TypeInAds().subscribe(
		data => { 
			this.filledFilters.Types = Object.assign([], data.Items)
		}, err => { }
		);

	}



	OnChange_FillStats() {

		var payload = {
			groupId: '',
			listKind: 'all',
			cityName: '',
			categoryId: '',
			typeId: '',
			priceRange: [],
			surfaceRange: [],

			lift: false,
			balcony: false,
			panoramic: false,
			garden: false,
			radiators: false,
			conditioner: false,
			garage: false,
			animalAdmit: false,

			// Services: {
			// 	Elevator: false,
			// 	Balcony: false,
			// 	Panoramic: false,
			// 	Garden: false,
			// 	Radiators: false,
			// 	Conditioner: false,
			// 	Garage: false,
			// 	animalsAdmit: false
			// },
			uiCulture: 'it'
		} 
		
		payload.priceRange[0]='0';
		payload.priceRange[1] = '1000000000';

		this.isPendingChanges = false;

		if (this.searchFilters.Contract != '' ) { payload.groupId = this.searchFilters.Contract; this.isPendingChanges = true; }
		if (this.searchFilters.City != '' ) { payload.cityName = this.searchFilters.City; this.isPendingChanges = true; }
		if (this.searchFilters.Category != '' ) { payload.categoryId = this.searchFilters.Category; this.isPendingChanges = true; }
		if (this.searchFilters.Type != '' ) { payload.typeId = this.searchFilters.Type; this.isPendingChanges = true; }
		
		if (this.searchFilters.Range.min != '0') { payload.priceRange[0] = this.searchFilters.Range.min; this.isPendingChanges = true; }
		if (this.searchFilters.Range.max != null || this.searchFilters.Range.max != undefined ) { 
			if (this.searchFilters.Range.max != '0') {
				payload.priceRange[1] = this.searchFilters.Range.max;
			} else {
				payload.priceRange[1] = '1000000000';
			}
			this.isPendingChanges = true;
		}

		payload.lift = this.searchFilters.Services.Elevator;
		payload.balcony = this.searchFilters.Services.Balcony;
		payload.panoramic = this.searchFilters.Services.Panoramic;
		payload.garden = this.searchFilters.Services.Garden;
		payload.radiators = this.searchFilters.Services.Radiators;
		payload.conditioner = this.searchFilters.Services.Conditioner;
		payload.garage = this.searchFilters.Services.Garage;
		payload.animalAdmit = this.searchFilters.Services.animalsAdmit;
		
		this.UpdateSearch(payload);
		
	}

	UpdateSearch(payload) {
		this.filler.Get_AdsListStats(payload).subscribe(
			data => {
				this.listStat = Object.assign([], data)          
			}, err => { }
		);
	}

	checkReset() {
		
	}

	resetSearchFilter() {
		this.isPendingChanges = false;

		this.searchFilters.Range.min = '0';
		this.searchFilters.Range.max = '0';

		this.searchFilters.surfaceRange = [];

		this.searchFilters.City = '';
		this.searchFilters.Contract = '0';
		this.searchFilters.Category = '0';
		this.searchFilters.Type = '0';

		this.searchFilters.Rooms = '';
		this.searchFilters.bathRooms = '';
		this.searchFilters.carParks = '';
		this.searchFilters.Services= {
		    Elevator: false,
		    Balcony: false,
		    Panoramic: false,
		    Garden: false,
		    Radiators: false,
		    Conditioner: false,
		    Garage: false,
		    animalsAdmit: false
		}

		this.OnChange_FillStats();
	}

	doSearch(){
		this.isPendingChanges = true;
		let navigationExtras: NavigationExtras = {
		queryParams:
		{
			Contract: this.searchFilters.Contract,
			Category: this.searchFilters.Category,
			Type: this.searchFilters.Type,
			City: this.searchFilters.City,
			PriceRangeFrom: this.searchFilters.Range.min,
			PriceRangeTo: this.searchFilters.Range.max,
			SurfaceRangeFrom: this.searchFilters.surfaceRange[0],
			SurfaceRangeTo: this.searchFilters.surfaceRange[1],
			HasLift: this.searchFilters.Services.Elevator,
			HasBalcony: this.searchFilters.Services.Balcony,
			IsPanoramic: this.searchFilters.Services.Panoramic,
			HasGarden: this.searchFilters.Services.Garden,
			HasRadiators: this.searchFilters.Services.Radiators,
			HasConditioner: this.searchFilters.Services.Conditioner,
			HasGarage: this.searchFilters.Services.Garage,
			IsAnimalsAdmit: this.searchFilters.Services.animalsAdmit,
			bathroomsPlusThan: this.searchFilters.bathRooms,
			carParkPlusThan: this.searchFilters.carParks,
			roomsPlusThan: this.searchFilters.Rooms
			}
		}
		this.router.navigate(['/list'], navigationExtras);
	}

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnsearchpanel/tnsearchpanel.component.ts